module.exports = __webpack_public_path__ + "img/mozzo 2.26180e07.jpeg";